import { render } from "./DesignCard.vue?vue&type=template&id=f0cdac3e&scoped=true"
const script = {}

import "./DesignCard.vue?vue&type=style&index=0&id=f0cdac3e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/energy-hub-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0cdac3e"]])

export default __exports__